import useNamespacedStorage, { getNamespacedStorageItem } from 'app/hooks/storage/useNamespacedStorage';

export const PERSISTED_SEARCH_KEY = 'ostroPersistedSearch';

export default function usePersistedSearch() {
  return useNamespacedStorage(PERSISTED_SEARCH_KEY, '');
}

export function getPersistedSearch() {
  return getNamespacedStorageItem(PERSISTED_SEARCH_KEY);
}
